<template>
	<div>
		<skeleton v-if="pending" width="100%" :height="106"/>
		<template v-else-if="linkInfo">
			<aspect-ratio-box v-if="linkInfo.type === 'youtube'" :ratio="16/9" class="relative">
				<iframe width="100%" height="100%" :src="linkInfo.url" :title="linkInfo.title" frameborder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen/>
			</aspect-ratio-box>
			<div v-else-if="['event', 'club', 'user'].includes(linkInfo.type)" class="px-16 lg:px-24 mt-16">
				<profile-preview :model="linkInfo.model" :to="$spoferanUrl(linkInfo.path)" outlined/>
			</div>
			<a v-else :href="linkInfo.url" target="_blank" rel="noopener" class="flex relative py-16 px-16 lg:px-24 hover:bg-gray-150 bg-gray-100">
				<div v-if="linkInfo.image" class="w-112 min-w-112 mr-16 none sm:block">
					<img :src="linkInfo.image" :alt="linkInfo.host" width="112" class="rounded"/>
				</div>
				<div class="flex-grow-x-1 overflow-hidden">
					<p v-if="linkInfo.title" class="text-sm font-bold font-heading leading-normal text-text-color mb-4 truncate">{{ linkInfo.title }}</p>
					<p v-if="linkInfo.description" class="text-xs sm:text-sm mb-6 leading-spaced text-subtext-color truncate-3-lines">{{ linkInfo.description }}</p>
					<div class="flex items-center">
						<Icon :icon="icons.external_link" xx-small color="gray-400"/>
						<p v-if="linkInfo.host" class="text-3xs sm:text-2xs text-gray-400 text-uppercase mb-0 ml-6 leading-none">{{ linkInfo.host }}</p>
						<p v-else-if="linkInfo.url" class="text-3xs sm:text-2xs text-gray-400 text-uppercase mb-0 ml-6 leading-none">{{ linkInfo.url }}</p>
					</div>
				</div>
			</a>
		</template>
	</div>
</template>

<script setup lang="ts">
import {externalLinkIcon} from "../../config";
import {onMounted, watch} from 'vue';
import {useNuxtApp, useApiFetch} from '#imports';

const props = defineProps<{
	// The link to show the preview for
	link: string
}>();

const icons = {
	external_link: externalLinkIcon
};

const {$api} = useNuxtApp();

const {reactiveData: linkInfo, pending, refresh} = await useApiFetch('/v1/crawl', {
	guest: true,
	immediate: false,
	lazyError: true,
	params: {
		url: props.link
	}
});

/**
 * Loads the info for the link from the server.
 */
function refreshLinkInfo() {
	if (!props.link) {
		linkInfo.value = null;
		return;
	}

	refresh();
}

watch(() => props.link, () => {
	refreshLinkInfo();
});

onMounted(() => {
	refreshLinkInfo()
});

</script>